/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const lightningstrike = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.911 7.91a.597.597 0 0 0-.508-.909H8.375v-5.25L4.089 8.717a.596.596 0 0 0 .508.909h2.028v5.25L10.91 7.91Z"
      clipRule="evenodd"
    />
  </svg>
)
export default lightningstrike
